import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    country: null,
    accountId: null,
    isAccountAllowed: false,
    isActive: false,
    productAccountIsActive: false,
    label: null,
    linkedAccounts: {},
    settings: {
        //frequency_activated: 'NO',
        ruleActivated: false,
        bootstrap_custom_segment_available: false,
        wam_factory_activated: false,
        wamfactory_logs_activated: false,
        allocationDashboardActivated: false
    },
    xDeviceInfo: {},
    userRole: null,
    userRights: null,
    namespaces: [],
    defaultNamespaceId: null,
    attributionCounterAudience: 0,
    attributionCounterTransfer: 0,
    dailyBootstrapLimit: 0,
    dailyPushOfStockLimit: 0,
    isLoading: false,
    customer: null
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
